import { type ClipType } from '@air/api/types';
import { getAssetPreviewType } from '@air/utils-clips/getAssetPreviewType';

import { exceedsBrowserImagePreviewLimit } from './exceedsBrowserImagePreviewLimit';

export type UploadPreviewAvailability = {
  apiUploadData: {
    ext: string;
    size?: number;
    type: ClipType;
  };
};

export const isPreviewAvailable = ({ apiUploadData: { type, ext, size } }: UploadPreviewAvailability) => {
  const webClipType = getAssetPreviewType({ ext, type });

  if (webClipType === 'photo' && size !== undefined && exceedsBrowserImagePreviewLimit(size)) {
    return false;
  }

  return webClipType === 'photo' || webClipType === 'video';
};
